export const POLL_INTERVAL = 10000;
